export default {
  requestsTotalCount: {
    id: 'bo_sellers_customer_care_all_requests_total_request_count',
    defaultMessage: '{count, plural, one {# request} other {# requests}}',
  },
  noRequestFoundLinkLabel: {
    id: 'bo_sellers_customer_care_all_requests_no_request_found_block_link_label',
    defaultMessage: 'Learn about the Orders page',
  },
  noRequestFoundDescription: {
    id: 'bo_sellers_customer_care_all_requests_no_request_found_block_description',
    defaultMessage:
      'Service requests last updated before September 2023 or more than 3 years old are found via the Orders page.',
  },
}
